angular.module('b2bLoginApp.filters').filter('postalCodePaddingFilter',
    ["countriesWithLeadingZeroesPostalCodes", function (countriesWithLeadingZeroesPostalCodes) {
        return function (input, country) {
            if (angular.isUndefined(input)) {
                return input;
            }

            return countriesWithLeadingZeroesPostalCodes.indexOf(country.toLowerCase()) !== -1 ? input.padStart(5, '0') : input;
        };
    }]);
